import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { I18NEXT_NAMESPACE, I18NextModule } from 'angular-i18next';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { DateTimeHelperService } from '../date-time-helper/date-time-helper.service';
import { DatepickerControlComponent } from '../datepicker-control/datepicker-control.component';
import { ActionHeaderComponent } from './action-header/action-header.component';
import { ButtonListComponent } from './button-list/button-list.component';
import { ActionButtonComponent } from './button/action/action-button.component';
import { ButtonComponent } from './button/button/button.component';
import { SmallActionButtonComponent } from './button/small-action/small-action-button.component';
import { CardComponent } from './card/card.component';
import { LabelComponent } from './forms/label/label.component';
import { InfoIconComponent } from './icons/info-icon/info-icon.component';
import { SeverityClassPipe } from './icons/info-icon/severity-class.pipe';
import { TextModalTitleComponent } from './modal/title/modal-title.component';
import { NavigationPanelComponent } from './panels/navigation-panel/navigation-panel.component';
import { DumbSectionHeaderComponent } from './section-header-dumb/section-header.component';
import { TextCardHeaderComponent } from './typography/card-header/card-header.component';
import { TextSectionHeaderComponent } from './typography/section-header/section-header.component';
import { TextSubtitleComponent } from './typography/text-subtitle/text-subtitle.component';
import { TextTitleComponent } from './typography/text-title/text-title.component';


const MaterialModules = [
  MatNativeDateModule,
  MatFormFieldModule,
  MatInputModule,
  MatDatepickerModule,
  MatButtonModule,
];


@NgModule({
  declarations: [
    ActionButtonComponent,
    ButtonComponent,
    SmallActionButtonComponent,
    TextCardHeaderComponent,
    TextModalTitleComponent,
    TextSectionHeaderComponent,
    TextSubtitleComponent,
    TextTitleComponent,
    ButtonListComponent,
    CardComponent,
    DumbSectionHeaderComponent,
    InfoIconComponent,
    SeverityClassPipe,
    NavigationPanelComponent,
    ActionHeaderComponent,
    LabelComponent,
    DatepickerControlComponent,
  ],
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, I18NextModule, CalendarModule, InputTextModule, ...MaterialModules],
  providers: [
    DateTimeHelperService,
    {
      provide: I18NEXT_NAMESPACE,
      useValue: ['module.hb-shared-ui'],
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ActionButtonComponent,
    ButtonComponent,
    SmallActionButtonComponent,
    TextCardHeaderComponent,
    TextModalTitleComponent,
    TextSectionHeaderComponent,
    TextSubtitleComponent,
    TextTitleComponent,
    ButtonListComponent,
    CardComponent,
    DumbSectionHeaderComponent,
    InfoIconComponent,
    NavigationPanelComponent,
    ActionHeaderComponent,
    LabelComponent,
    DatepickerControlComponent,
  ],
})
export class HbSharedUiModule { }
